import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import EA from '../helpers/init';

export default EA.Methods.testimonialCardSliderHandler = ($this) => {
    const slider = $this.querySelector('.testimonial-card-swiper');

    new Swiper(slider, {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: true,
        loopAdditionalSlides: 1,
        centerInsufficientSlides: true,
        autoplay: {
            delay: 4000,
        },
        on: {
            afterInit(s) {
                if(slider.querySelectorAll('.swiper-slide').length > 5) {
                    s.slidePrev(0, false);
                    s.slideNext(0, false);
                }
            },
        },
    });
};